<template>
	<div class="this-page">
		<template>
			<toolBar useSearch @search="searchOrder" @clear="clearSearch"/>
		</template>
		<template>
			<el-table :data="orders" stripe style="width: 100%" size="small" :height="tableHeight">
				<!--<el-table-column prop="id" label="内部编号" width="70">
				</el-table-column>-->

				<el-table-column prop="no" label="运单号" width="130" fixed>
				</el-table-column>
				<el-table-column prop="posterDetail" label="寄件人" min-width="300">
				</el-table-column>
				<el-table-column prop="type" label="寄件方式" width="90">
					<template slot-scope="scope">
						<el-tag type="success" size="small" v-if="scope.row.method == 1">网点自寄</el-tag>
						<el-tag type="warning" size="small" v-if="scope.row.method == 2">上门取件</el-tag>
						<el-tag type="danger" size="small" v-if="scope.row.method == 0">系统空单</el-tag>
						<el-tag type="danger" size="small" v-if="scope.row.method == 4">集运拼团</el-tag>
						<el-tag size="small" v-if="scope.row.method == 3">集运打包</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="schedules" label="预约" width="170">
				</el-table-column>
				<el-table-column prop="box" label="纸箱数" width="60">
				</el-table-column>
				<el-table-column prop="type" label="寄托物" width="70">
					<template slot-scope="scope">
						<el-tooltip placement="right">
							<div slot="content">
								<template v-for="(item,i) in scope.row.items">{{item.name}} * {{item.number}}件 <br> </template>
							</div>
							<el-button size="mini" type="text">{{scope.row.items.length}}项</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="created" label="下单时间" width="160">
				</el-table-column>
				<el-table-column prop="userRemark" label="客户备注" min-width="150">
				</el-table-column>
				<el-table-column prop="sysRemark" label="内部备注" min-width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="openRemark(scope.row.id,scope.row.sysRemark === '-'?'':scope.row.sysRemark)"><i class="el-icon-edit"></i></el-button> {{scope.row.sysRemark || '-'}} 
					</template>
				</el-table-column>
				<el-table-column prop="type" label="预分配" width="60" fixed="right">
					<template slot-scope="scope">
						<el-switch
						size="mini"
						  v-model="scope.row.prePickupId == 0 ?false:true"
						  active-color="#13ce66"
						  inactive-color="#ff4949"
						  @change="uploadPrePickupId(scope.row.id,scope.row.prePickupId == 0 ?1:0)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="运单状态" width="80">
					<template slot-scope="scope">
						<el-tag type="info" size="small" v-if="scope.row.status == -1">已取消</el-tag>
						<el-tag type="warning" size="small" v-if="scope.row.status == 0">待收件</el-tag>
						<el-tag type="warning" size="small" v-if="scope.row.status == 1">待打包</el-tag>
						<el-tag type="danger" size="small" v-if="scope.row.status == 2">待支付</el-tag>
						<el-tag type="warning" size="small" v-if="scope.row.status == 3">待出库</el-tag>
						<el-tag type="success" size="small" v-if="scope.row.status == 4">运输中</el-tag>
						<el-tag type="success" size="small" v-if="scope.row.status == 5">转投成功</el-tag>
						<el-tag type="success" size="small" v-if="scope.row.status == 6">派件</el-tag>
						<el-tag type="success" size="small" v-if="scope.row.status == 7">妥投</el-tag>
						<el-tag type="info" size="small" v-if="scope.row.status == 8">存库</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="操作" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button-group v-if="scope.row.status == 0">

							<el-button size="mini" type="primary" icon="el-icon-takeaway-box" @click="pickup(scope.row.id)">收件</el-button>
							<el-button size="mini" type="danger" icon="el-icon-circle-close" @click="cancelOrder(scope.row.id)">取消</el-button>
						</el-button-group>
						<el-button-group v-if="scope.row.status == 1">

							<el-button size="mini" type="primary" icon="el-icon-folder-checked" @click="showPack(scope.row)">打包</el-button>
							<el-button size="mini" type="danger" icon="el-icon-circle-close" @click="cancelOrder(scope.row.id)">取消</el-button>
						</el-button-group>
						<el-button-group v-if="scope.row.status == 2">

							<el-button size="mini" type="success" icon="el-icon-circle-check" @click="offlinePay(scope.row.id)">线下付</el-button>
							<el-button size="mini" type="danger" icon="el-icon-circle-close" @click="cancelOrder(scope.row.id)">取消</el-button>
						</el-button-group>


						<el-button size="mini" v-if="scope.row.status == 3" type="success" icon="el-icon-circle-check" @click="sendOut(scope.row.id)">出库</el-button>

						<el-button size="mini" type="primary" icon="el-icon-position" @click="showProgress(scope.row.id)" v-if="scope.row.status == 4">轨迹</el-button>
						<el-button-group v-if="scope.row.status == 4">
							<!--<el-button type="success" icon="el-icon-circle-check" @click="cancelOrder(scope.row.id)">结束</el-button>-->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<template>
				<el-pagination style="margin-top:20px" :current-page="page" background layout="prev, pager, next" :page-count="pageCount"
				 @current-change="pageChange">
				</el-pagination>
			</template>
		</template>
		<template>
			<el-dialog title="打包计费" :visible.sync="packShow" :before-close="handlePackClose">
				<el-form :model="packForm" :inline="true">
					<el-form-item label="保价金额" :label-width="formLabelWidth">
						<el-input v-model="packForm.insure" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="保价费用" :label-width="formLabelWidth">
						<el-input v-model="packForm.price.insure" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="取件费用" :label-width="formLabelWidth">
						<el-input v-model="packForm.price.pickup" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="打包费用" :label-width="formLabelWidth">
						<el-input v-model="packForm.price.pack" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="预约纸箱" :label-width="formLabelWidth">
						<el-input v-model="packForm.box" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="纸箱计费" :label-width="formLabelWidth">
						<el-input v-model="packForm.price.box" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="其他费用" :label-width="formLabelWidth">
						<el-input v-model="packForm.price.other" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="运费规则" :label-width="formLabelWidth">
						<el-select v-model="packForm.priceMethod" placeholder="请选择计费规则">
							<el-option label="整单计费" value="1"></el-option>
							<el-option label="重量计费" value="2"></el-option>
							<el-option label="体积计费" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="整单运费" :label-width="formLabelWidth" v-if="packForm.priceMethod == '1'">
						<el-input v-model="packForm.price.express" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="重量运费" :label-width="formLabelWidth" v-if="packForm.priceMethod == '2'">
						<el-input v-model="packForm.price.express" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="总重量(kg)" :label-width="formLabelWidth" v-if="packForm.priceMethod == '2'">
						<el-input v-model="packForm.weight" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="体积运费" :label-width="formLabelWidth" v-if="packForm.priceMethod == '3'">
						<el-input v-model="packForm.price.express" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="总体积" :label-width="formLabelWidth" v-if="packForm.priceMethod == '3'">
						<el-input v-model="packForm.volume" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
					<el-form-item label="合计支付费用" v-if="packForm.priceMethod" :label-width="formLabelWidth">
						<el-input v-model="packForm.price.total" autocomplete="off" tyle="number"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="calcPackPrice()" v-if="packForm.priceMethod">自动计算合计费用</el-button>
					<el-button @click="cancelPack()">取 消</el-button>
					<el-button type="primary" @click="confirmPack()">确 定</el-button>
				</div>
			</el-dialog>
		</template>
		<template>
			<el-dialog title="订单出库" :visible.sync="sendShow">
				<el-form>

					<el-form-item label="运输路线" :label-width="formLabelWidth">
						<el-select v-model="sendRoute" placeholder="请选择运输路线">
							<el-option label="新中海运" value="1"></el-option>
							<el-option label="新中空运" value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="sendShow = false">取 消</el-button>
					<el-button type="primary" @click="confirmSend()">确 定</el-button>
				</div>
			</el-dialog>
		</template>
		<template>
			<el-dialog title="运单轨迹" :visible.sync="progressShow">
				<el-table :data="progressResult">
					<el-table-column property="title" label="标题"></el-table-column>
					<el-table-column property="description" label="描述"></el-table-column>
					<!-- <el-table-column property="created" label="时间" width="160"></el-table-column>-->
					<el-table-column property="created" label="时间" width="250">
						<template slot-scope="scope">
							<el-date-picker value-format="yyyy/MM/dd HH:mm:ss" :clearable="false" v-model="progressResult[scope.$index].created"
							 type="datetime" @change="updateProgressTime(progressResult[scope.$index].created,progressResult[scope.$index].id)"
							 placeholder="自定义时间">
							</el-date-picker>
						</template>
					</el-table-column>
				</el-table>
				<div slot="footer" class="dialog-footer">
					<el-button @click="progressShow = false">取 消</el-button>
					<el-button type="primary" @click="transOrder()">自动流转</el-button>
				</div>
			</el-dialog>
		</template>

	</div>
</template>
<script>
	import toolBar from '../../components/tool-bar/index.vue'
	export default {
		components:{
			toolBar
		},
		data() {
			return {
				tableHeight: document.documentElement.clientHeight - 165 + 'px',
				load: {
					orders: false
				},
				page: 1,
				searchValue:'',
				pageCount: 1,
				orders: [],
				packShow: false,
				formLabelWidth: '120px',
				packForm: {
					id: '',
					box: 0,
					priceMethod: '',
					insure: 0,
					price: {
						other: 0,
						insure: 0,
						pickup: 0,
						pack: 0,
						box: 0,
						express: 0,
						total: 0
					},
					weight: 0,
					volume: 0
				},
				sendShow: false,
				sendId: '',
				sendRoute: '',
				progressShow: false,
				progressId: '',
				progressResult: [],
				cusProgressTimeId: '',
				cusProgressTime: ''
			}
		},
		mounted() {
			var that = this;
			// <!--把window.onresize事件挂在到mounted函数上-->
			window.onresize = () => {
				return (() => {
				  window.fullHeight = document.documentElement.clientHeight;
					
				  that.tableHeight = window.fullHeight - 165 + 'px';  // 高
					
				})()
			  };
			this.getOrders()
		},
		methods: {
			handleSelect(key, keyPath) {
				console.log(key, keyPath);
			},
			getOrders() {
				this.$fetch.post('Order/getExpressOrder', {
					page: this.page,
					status: 0,
					search:this.searchValue
				}, true).then(res => {
					this.load.orders = true
					this.orders = res.result
					this.pageCount = res.page
				})
			},
			uploadPrePickupId(id,pid){
				this.$fetch.post('Order/updatePrePickupId', {
					pid: pid,
					id:id
				}, true).then(res => {
					this.getOrders()
				})
			},
			cancelOrder(id) {
				this.$fetch.post('Order/cancelExpressOrder', {
					id: id
				}, true).then(res => {
					this.getOrders()
				})
			},
			pickup(id) {
				this.$fetch.post('Order/pickupExpressOrder', {
					id: id
				}, true).then(res => {
					this.getOrders()
				})
			},
			offlinePay(id) {
				this.$fetch.post('Order/payExpressOrder', {
					id: id
				}, true).then(res => {
					this.getOrders()
				})
			},
			showPack(item) {
				this.packForm.id = item.id
				this.packForm.box = item.box
				this.packForm.price.box = item.box * 5
				this.packForm.insure = item.insure
				this.packForm.price.insure = item.priceInsure
				this.packShow = true
			},
			handlePackClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			cancelPack() {
				this.packShow = false
			},
			calcPackPrice() {
				let price = 1 * this.packForm.price.box + 1 * this.packForm.price.insure + 1 * this.packForm.price.pack + 1 * this.packForm
					.price.pickup + 1 * this.packForm.price.other + 1 * this.packForm.price.express
				this.packForm.price.total = price
			},
			confirmPack() {
				this.$fetch.post('Order/packExpressOrder', {
					pack: this.packForm
				}, true).then(res => {
					this.packShow = false
					this.getOrders()
				})
			},
			confirmSend() {
				this.$fetch.post('Order/sendExpressOrder', {
					id: this.sendId,
					route: this.sendRoute
				}, true).then(res => {
					this.sendShow = false
					this.getOrders()
				})
			},
			sendOut(id) {
				this.sendShow = true
				this.sendId = id
			},
			showProgress(id) {
				this.$fetch.post('Order/getExpressProgress', {
					id: id
				}, true).then(res => {
					this.progressShow = true
					this.progressId = id
					this.progressResult = res
				})
			},
			transOrder() {
				this.$fetch.post('Order/transExpressProgress', {
					id: this.progressId
				}, true).then(res => {
					this.showProgress(this.progressId)
				})
			},
			updateProgressTime(e, i) {

				this.$fetch.post('Order/updateExpressProgressTime', {
					id: i,
					time: e
				}, true).then(res => {

				})
			},
			pageChange(e) {
				this.page = e
				this.getOrders()
			},
			searchOrder(e){
				if(!e){
					this.$message({
						type: 'info',
						message: '当前没有搜索任何信息'
					});  
						return false
				}
				this.searchValue = e
				this.page = 1
				this.getOrders()
				console.log(e)
			},
			clearSearch(){
				console.log('清空搜索')
				this.searchValue = ''
				this.page = 1
				this.getOrders()
			},
			openRemark(id,old) {
			        this.$prompt('请输入系统备注', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
						inputValue:old,
						inputType:'textarea'
			        }).then(({ value }) => {
			          this.updateSysRemark(id,value)
			        }).catch(() => {
			          this.$message({
			            type: 'info',
			            message: '取消输入'
			          });       
			        });
			},
			updateSysRemark(id,value){
				this.$fetch.post('Order/updateSysRemark', {
					id: id,
					value: value
				}, true).then(res => {
					this.getOrders()
				})
			}

		}
	}
</script>

<style scoped>
	.this-page {
		padding: 10px;
		background-color: #FFFFFF;
	}
</style>
